import Collaborate16 from '@carbon/icons-react/es/collaborate/16';
import Erase16 from '@carbon/icons-react/es/erase/16';
import Events16 from '@carbon/icons-react/es/events/16';
import Friendship16 from '@carbon/icons-react/es/friendship/16';
import Migrate16 from '@carbon/icons-react/es/migrate--alt/16';
import UserFollow16 from '@carbon/icons-react/es/user--follow/16';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ResourceRequestType } from 'api/resource-request/types';

const ResourceRequestTypeRendererStyled = styled.div`
  display: flex;
  .icon {
    margin-right: var(--spacing-03);
  }
`;

interface ResourceRequestTypeRendererProps {
  requestType: ResourceRequestType;
}

const iconMap = {
  NEW_TEAM_MEMBER: <UserFollow16 />,
  EXTENSION: <Friendship16 />,
  REPLACEMENT: <Collaborate16 />,
  SHIFT_ALLOCATION: <Migrate16 />,
  PLACEHOLDER: <Events16 />,
  DELETE_ALLOCATION: <Erase16 />,
} as const;

export const ResourceRequestTypeRenderer: React.FC<ResourceRequestTypeRendererProps> =
  ({ requestType }) => {
    return (
      <ResourceRequestTypeRendererStyled>
        <div className="icon">{iconMap[requestType]}</div>
        <div>
          <FormattedMessage id={`apps.resource_request.${requestType}.title`} />
        </div>
      </ResourceRequestTypeRendererStyled>
    );
  };
